import { RefObject, useEffect } from 'react';

const useCloseClick = (ref: RefObject<HTMLDetailsElement>) => {
  const handleClick = () => {
    (ref.current as Element)?.removeAttribute('open');
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useCloseClick;
